var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-table",
        {
          staticClass: "evaluation-table",
          attrs: {
            data: _vm.data,
            draggable: false,
            detailed: "",
            "show-detail-icon": "",
          },
          scopedSlots: _vm._u([
            {
              key: "detail",
              fn: function ({ row }) {
                return [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-6" }, [
                      _vm.showExplanations(row)
                        ? _c("div", { staticClass: "explanations column" }, [
                            _c("p", { staticClass: "has-text-weight-medium" }, [
                              _vm._v(
                                "La simulación no pudo ser pre-aprobada porque:"
                              ),
                            ]),
                            _c(
                              "ul",
                              { staticClass: "fa-ul" },
                              _vm._l(
                                row.explanations,
                                function (reason, index) {
                                  return _c("li", { key: index }, [
                                    _c("span", { staticClass: "fa-li" }, [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-circle-arrow-right has-text-primary",
                                      }),
                                    ]),
                                    _vm._v(" " + _vm._s(reason) + " "),
                                  ])
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm.showMessages(row)
                        ? _c("div", { staticClass: "messages column" }, [
                            _c("p", { staticClass: "has-text-weight-medium" }, [
                              _vm._v("Gestiones a realizar:"),
                            ]),
                            _c(
                              "ul",
                              { staticClass: "fa-ul" },
                              _vm._l(row.messages, function (task, index) {
                                return _c("li", { key: index }, [
                                  _c("span", { staticClass: "fa-li" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-circle-arrow-right has-text-primary",
                                    }),
                                  ]),
                                  _vm._v(" " + _vm._s(task) + " "),
                                ])
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      { staticClass: "column is-6" },
                      [
                        _c(
                          "b-collapse",
                          {
                            attrs: { open: false, position: "is-bottom" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "trigger",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            "aria-controls":
                                              "contentIdForA11y4",
                                            "aria-expanded": props.open,
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: {
                                              icon: !props.open
                                                ? "caret-down"
                                                : "caret-up",
                                            },
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                !props.open
                                                  ? "Logs..."
                                                  : "Ocultar logs..."
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "ul",
                              { staticClass: "logs" },
                              _vm._l(row.reasonsError, function (error, index) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "is-size-7" },
                                  [_vm._v(" " + _vm._s(error) + " ")]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c("b-table-column", {
            staticClass: "featured-column",
            attrs: { field: "index", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "has-text-primary" }, [
                      _vm._v("Evaluación " + _vm._s(row.index)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "applicationDate", label: "Fecha" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.applicationDate) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "applicant", label: "Solicitante" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.applicant) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "creditAmount", label: "Monto del crédito" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatNumberByCountry(row.creditAmount)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "commercialValue", label: "Monto del vivienda" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatNumberByCountry(row.commercialValue)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "result", label: "Resultado" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "b-tag",
                      {
                        staticClass: "result-icon-list",
                        attrs: {
                          type: `${
                            _vm.getEvaluationResult(row).tagClass
                          } is-light`,
                          rounded: "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getEvaluationResult(row).evaluationResultLabel
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "simulation", label: "Simulación" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "data-cy": "open-simulation",
                          to: _vm.getSimulationLink(row),
                        },
                      },
                      [_vm._v(" Ver ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-table-column",
            { attrs: { field: "document", label: "Reporte" } },
            [_vm._v(" -- ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }